<!-- 顶部 -->
<template>
  <header class="header">
    <div class="topbar">
      <div class="in">
        <span>欢迎访问四川省建协人才服务中心</span>
        <div class="nowtime">
          <i class="el-icon-phone-outline"></i>
          <span>服务热线：400-888-8888</span>
        </div>
      </div>
    </div>
    <div class="topInfo">
      <div class="in">
        <router-link to="/">
          <img
            class="logo"
            src="@/assets/logo.png"
            alt="成都市武侯区产业经济与社会事业发展人才促进协会"
          />
        </router-link>
        <div class="right">
          <el-input
            size="small"
            placeholder="请输入关键词"
            v-model="searchData"
            @keyup.native.enter="navToSearch"
          ></el-input>
          <el-button
            size="small"
            icon="el-icon-search"
            type="danger"
            @click="navToSearch"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            v-show="!token"
            @click="navToLogin"
            >登录</el-button
          >
          <el-dropdown @command="dropdownChange" v-show="token">
            <div class="dropdown-out">
              <img
                :src="URL + userInfo.imgUrl"
                class="avatar"
                v-show="userInfo.imgUrl"
              />
              <img
                src="@/assets/avatar.png"
                class="avatar"
                v-show="!userInfo.imgUrl"
              />
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/mine/profile"
                >个人中心</el-dropdown-item
              >
              <el-dropdown-item command="/mine/myExam"
                >考试记录</el-dropdown-item
              >
              <el-dropdown-item command="/mine/myCertificate"
                >我的证书</el-dropdown-item
              >
              <el-dropdown-item command="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="icons">
          <div class="open" v-show="!mShow" @click="mShow = true">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="close" v-show="mShow" @click="mShow = false">
            <img src="@/assets/close.png" alt="" />
          </div>
        </div>
        <div class="nav-box" v-show="mShow" @click="mShow = false">
          <div class="navs" @click.stop>
            <div
              :class="{ nav: true, active: item.path == $route.path }"
              v-for="item in navList"
              :key="item.path"
              @click="navTo(item.path)"
            >
              <div class="title">{{ item.name }}</div>
              <div class="subs">
                <div class="sub" v-for="sub in item.children" :key="sub.path">
                  {{ sub.name }}
                </div>
              </div>
            </div>
            <div
              :class="{ nav: true, active: '/mine/profile' == $route.path }"
              v-show="token"
            >
              <div class="title">个人中心</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-box">
      <div class="navs" @click.stop>
        <div
          :class="{ nav: true, active: item.path == $route.path }"
          v-for="item in navList"
          :key="item.path"
          @click="navTo(item.path)"
        >
          <div class="title">{{ item.name }}</div>
          <div class="subs">
            <div class="sub" v-for="sub in item.subs" :key="sub.path">
              {{ sub.name }}
            </div>
          </div>
        </div>
        <div
          :class="{ nav: true, active: '/mine/profile' == $route.path }"
          @click="navTo('/mine/profile')"
          v-show="token"
        >
          <div class="title">个人中心</div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { menuRoutes } from "../../router/menuRoutes";
import { URL } from "../../util/config";
export default {
  data() {
    return {
      URL,
      navList: [],
      token: null,
      userInfo: {},
      mShow: false,
      searchData: "",
    };
  },
  props: {
    globalData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    $route() {
      this.token = localStorage.getItem("token");
      if (this.token) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      }
    },
  },
  created() {
    this.token = localStorage.getItem("token");
    if (this.token) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }
    // 筛选处理
    this.navList = menuRoutes.filter((ele) => {
      return !ele.meta.hide;
    });
  },
  mounted() {},
  methods: {
    navTo(path) {
      if (path != this.$route.path) {
        this.$router.push(path);
        this.mShow = false;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    navToSearch() {
      if (this.searchData != "") {
        this.$router.push("/search?content=" + this.searchData);
      }
    },
    navToLogin() {
      this.$router.push("/login");
    },
    dropdownChange(command) {
      if (command == "exit") {
        // 退出登录
        this.$confirm("确认退出登录？", "提示", {
          type: "warning",
        }).then(() => {
          if (this.$route.path == "/") {
            location.reload();
          } else {
            this.$router.push("/");
          }
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
        });
        return;
      }
      this.$router.push(command);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes rotateFadeIn {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.dropdown-out {
  height: 100%;
  margin-left: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;

  .avatar {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
  }
}
.header {
  width: 100%;

  --main-width: 1200px;

  .topbar {
    line-height: 36px;
    background-color: #363636;
    color: #fff;
    font-size: 14px;

    .in {
      width: var(--main-width);
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      font-size: 12px;

      .nowtime {
        white-space: pre-wrap;

        i {
          margin-right: 5px;
        }
      }
    }
  }
  .topInfo {
    height: 134px;
    background-color: #fff;

    .in {
      width: var(--main-width);
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        width: auto;
        height: 95px;
        line-height: 95px;
      }
      .right {
        width: 300px;
        display: flex;
        align-items: center;
      }
      .icons {
        display: none;

        .open {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          animation: rotateFadeIn 0.1s linear;

          span {
            display: block;
            height: 2px;
            background-color: $theme;

            &:first-child {
              width: 24px;
            }
            &:nth-child(2) {
              width: 12px;
              margin: 6px 0;
            }
            &:last-child {
              width: 18px;
            }
          }
        }
        .close {
          animation: rotateFadeIn 0.1s linear;

          img {
            width: 24px;
            display: block;
          }
        }
      }
      .nav-box {
        display: none;
      }
    }
  }
  .nav-box {
    background-color: $theme;
    color: #fff;

    .navs {
      width: var(--main-width);
      margin: 0 auto;
      display: flex;

      .nav {
        width: 120px;
        text-align: center;
        border-right: 1px solid $subTheme;
        font-size: 18px;
        line-height: 50px;
        color: #fff;

        &:first-child {
          border-left: 1px solid $subTheme;
        }

        &:hover {
          background-color: $subTheme;
          cursor: pointer;
        }
      }
      .active {
        background-color: $subTheme;
      }
    }
  }
}
@media (max-width: 750px) {
  .topbar {
    display: none;
  }
  .header {
    --main-width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;

    .topInfo {
      height: 100%;
      border-bottom: 1px solid #e8e8e8;
      box-shadow: 0 0 5px #999;

      .in {
        padding: 0 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {
          height: 30px;
          margin: 10px 0;
          display: block;
        }
        .icons,
        .nav-box {
          display: block;
        }
        .right {
          display: none;
        }
      }
    }
    .nav-box {
      width: 100vw;
      height: 100vh;
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 999;
      background-color: rgba($color: #000000, $alpha: 0.5);
      border-bottom: 0;
      display: none;

      .navs {
        width: 100%;
        background-color: #fff;
        flex-direction: column;

        .nav {
          width: 100%;
          border: 0;
          padding: 0;

          &:first-child {
            border-left: 0;
          }
          &:hover {
            background-color: #fff;
          }
          .title {
            color: #333;
            font-size: 15px;
            line-height: 40px;
            padding: 0 15px;
          }
        }
        .active .title {
          color: #fff;
        }
      }
    }
  }
}
</style>
